import React, { useEffect, useState } from "react";
import BookCover from "./BookCover";
import { useNavigate } from "react-router-dom";
import { getLocalizedAssetPath } from "../../utils/getLocalizedLogo";

const BookCoverList = ({
  books,
  currentPage,
  booksPerPage,
  pageName,
  onStorySelect,
  variant,
  isSelectMode,
  selectedBookId,
  onAllImagesLoaded,
  setSelectedBookId,
}) => {
  const [dynamicBooksPerPage, setDynamicBooksPerPage] = useState(8);
  const [loadedCount, setLoadedCount] = useState(0);
  const navigate = useNavigate();

  console.log("books", books);
  useEffect(() => {
    // 새 페이지로 넘어가면 로딩 초기화
    setLoadedCount(0);
  }, [currentPage, books]);

  // 모든 이미지 로딩 완료 감지
  useEffect(() => {
    if (currentBooks?.length > 0 && loadedCount === currentBooks.length) {
      onAllImagesLoaded?.();
    }
  }, [loadedCount]);

  useEffect(() => {
    if (booksPerPage == null && variant !== "home") {
      const updateBooksPerPage = () => {
        if (window.innerWidth < 1025) {
          setDynamicBooksPerPage(4);
        } else if (window.innerWidth < 1440) {
          setDynamicBooksPerPage(6);
        } else {
          setDynamicBooksPerPage(8);
        }
      };
      updateBooksPerPage();
      window.addEventListener("resize", updateBooksPerPage);
      return () => {
        window.removeEventListener("resize", updateBooksPerPage);
      };
    }
  }, [booksPerPage, variant]);

  let currentBooks = [];

  if (variant === "home") {
    currentBooks = books.slice(0, 3);
  } else {
    const perPage = booksPerPage ?? dynamicBooksPerPage;

    if (pageName === "storyland" || pageName === "myStorybook") {
      const startIndex = (currentPage - 1) * perPage;
      const endIndex = startIndex + perPage;
      currentBooks = books.slice(startIndex, endIndex);
    } else {
      const firstPageCount = perPage - 1;

      let startIndex;
      let endIndex;

      if (currentPage === 1) {
        startIndex = 0;
        endIndex = firstPageCount;
      } else {
        startIndex = firstPageCount + (currentPage - 2) * perPage;
        endIndex = startIndex + perPage;
      }

      currentBooks = books.slice(startIndex, endIndex);
    }
  }

  const goToBranch = () => {
    navigate("/making/custom");
  };

  return (
    <ul className="box-conts">
      {currentPage === 1 &&
        pageName !== "storyland" &&
        pageName !== "myStorybook" && (
          <li className="create-story-btn">
            <button onClick={goToBranch}>
              <img
                src={getLocalizedAssetPath("/images/book/custom_cover.svg")}
                alt="Create story"
              />
            </button>
          </li>
        )}
      {currentBooks.map((book, index) => (
        <BookCover
          key={book.id || index}
          {...book}
          index={index}
          variant={variant}
          bookId={book.book_id}
          selectedBookId={selectedBookId}
          isSelectMode={isSelectMode}
          onClick={() => onStorySelect(book)}
          hasAudio={book.has_audiobook}
          onImageLoaded={() => setLoadedCount((c) => c + 1)}
        />
      ))}
    </ul>
  );
};

export default BookCoverList;
